<template>
	<div>
		<el-dialog
			:visible.sync="viewQuestionImagesDialog"
			:before-close="handleClose"
			:fullscreen="true"
			title="Media"
			class="header"
		>
			<div v-if="fileURLArrayNew.length">
				<div
					v-if="isImage(fileURLArrayNew[currentItemIndex].fileDetails.name)"
					class="image-container"
				>
					<img
						class="uploaded-image"
						:src="fileURLArrayNew[currentItemIndex].src"
						alt="Image Preview"
						id="preview-img"
					/>
				</div>
				<video
					v-else-if="
						isVideo(fileURLArrayNew[currentItemIndex].fileDetails.name)
					"
					:src="fileURLArrayNew[currentItemIndex].src"
					controls
					id="preview-video"
					style="width: 100%; height: 500px; object-fit: cover"
				></video>
				<div
					v-else-if="isCSV(fileURLArrayNew[currentItemIndex].fileDetails.name)"
					style="text-align: center"
				>
					<img
						@click="show_excel(fileURLArrayNew[currentItemIndex].src)"
						src="../../../assets/icons/excel.png"
						style="width: 400px; height: 480px; object-fit: cover"
					/>
					<h3>Click on the image to download .csv file</h3>
				</div>
				<div
					v-else-if="isPDF(fileURLArrayNew[currentItemIndex].fileDetails.name)"
				>
					<div>
						<PDFViewer
							ref="pdfViewer"
							:source="fileURLArrayNew[currentItemIndex].src"
							style="width: 100%"
							:style="
								fileURLArrayNew.length == 1 ? 'height: 600px' : 'height: 500px'
							"
							:key="'pdf_' + currentItemIndex"
							:rendering-text="renderingText"
							@rendered="onPDFRendered(currentItemIndex)"
							@download="handleDownload"
						/>
					</div>
				</div>
				<div
					v-if="fileURLArrayNew.length > 1"
					style="text-align: center; margin-top: 30px"
				>
					<el-button
						@click="prevItem"
						:disabled="currentItemIndex === 0"
						class="button-class-white"
						icon="el-icon-d-arrow-left"
					>
						Previous
					</el-button>
					<el-button
						style="margin-left: 50px"
						@click="nextItem"
						:disabled="currentItemIndex === fileURLArrayNew.length - 1"
						class="button-class-white"
						icon="el-icon-d-arrow-right"
					>
						Next
					</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import PDFViewer from "pdf-viewer-vue/dist/vue2-pdf-viewer";

export default {
	props: {
		viewQuestionImagesDialog: Boolean,
		imagesArray: Array,
		currentItemIndex: Number,
	},
	components: {
		PDFViewer,
	},
	data: () => ({
		renderingText: "Loading...",
		fileURLArrayNew: [],
	}),
	watch: {
		viewQuestionImagesDialog(val) {
			if (val) {
				this.fileURLArrayNew = this.imagesArray;
				this.$nextTick(() => {
					this.$forceUpdate();
				});
			}
		},
	},
	methods: {
		isImage(fileName) {
			return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(fileName);
		},
		isVideo(fileName) {
			return /\.(mp4|mov|wmv|avi|avchd|flv|f4v|swf|mkv|webm|mpg|mp2|mpeg|mpe|mpv|video)$/i.test(
				fileName
			);
		},
		isCSV(fileName) {
			return /\.(csv|sheet)$/i.test(fileName);
		},
		isPDF(fileName) {
			return /\.(pdf)$/i.test(fileName);
		},
		prevItem() {
			if (this.currentItemIndex > 0) {
				this.$emit("update:currentItemIndex", this.currentItemIndex - 1);
			}
		},
		nextItem() {
			if (this.currentItemIndex < this.fileURLArrayNew.length - 1) {
				this.$emit("update:currentItemIndex", this.currentItemIndex + 1);
			}
		},
		async handleDownload(pdfInfo) {
			try {
				const response = await fetch(pdfInfo.src);
				if (!response.ok) {
					throw new Error("Network response was not ok");
				}
				const pdfData = await response.blob();
				const link = document.createElement("a");
				link.href = window.URL.createObjectURL(pdfData);
				link.download = pdfInfo.filename;
				link.click();
				window.URL.revokeObjectURL(link.href);
			} catch (error) {
				console.error("Error downloading PDF:", error.message);
			}
		},
		onPDFRendered(index, src) {
			console.log(this.$refs.pdfViewer, "pdfViewer");
			console.log("PDF rendered at index:", index);
			setTimeout(() => {
				this.$nextTick(() => {
					this.$forceUpdate();
				});
			}, 500);
			this.$nextTick(() => {
				this.$forceUpdate();
			});
		},
		handleClose() {
			this.$emit("close");
		},
		show_excel(excel) {
			window.open(excel);
		},
	},
};
</script>

<style></style>
